import { lazy } from 'react';
const BatchLiabilityCreation = lazy(() => import('./BatchLiabilityCreation'));

const BatchLiabilityCreationRoutes = [
  {
    path: '/batchliabilitycreation',
    component: BatchLiabilityCreation
  }
];

export default BatchLiabilityCreationRoutes;
